import {CSSProperties, ReactElement} from 'react';
import IconButton from '@/ui/IconButton/IconButton';
import Icons, {IconType} from '@/ui/IconButton/Icons';
import './paymentMethodIcon.less';

const ZelleSvg = ({style}: {style?: CSSProperties}) => (
    <svg xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 48 48"
         style={{width: '1em', height: '1em', verticalAlign: '-0.125em', ...style}}
         aria-label="Zelle"
    >
        <path fill="currentColor" d="M35,42H13c-3.866,0-7-3.134-7-7V13c0-3.866,3.134-7,7-7h22c3.866,0,7,3.134,7,7v22 C42,38.866,38.866,42,35,42z"/>
        <path fill="#fff" d="M17.5,18.5h14c0.552,0,1-0.448,1-1V15c0-0.552-0.448-1-1-1h-14c-0.552,0-1,0.448-1,1v2.5 C16.5,18.052,16.948,18.5,17.5,18.5z"/>
        <path fill="#fff" d="M17,34.5h14.5c0.552,0,1-0.448,1-1V31c0-0.552-0.448-1-1-1H17c-0.552,0-1,0.448-1,1v2.5 C16,34.052,16.448,34.5,17,34.5z"/>
        <path fill="#fff" d="M22.25,11v6c0,0.276,0.224,0.5,0.5,0.5h3.5c0.276,0,0.5-0.224,0.5-0.5v-6c0-0.276-0.224-0.5-0.5-0.5 h-3.5C22.474,10.5,22.25,10.724,22.25,11z"/>
        <path fill="#fff" d="M22.25,32v6c0,0.276,0.224,0.5,0.5,0.5h3.5c0.276,0,0.5-0.224,0.5-0.5v-6c0-0.276-0.224-0.5-0.5-0.5 h-3.5C22.474,31.5,22.25,31.724,22.25,32z"/>
        <path fill="#fff" d="M16.578,30.938H22l10.294-12.839c0.178-0.222,0.019-0.552-0.266-0.552H26.5L16.275,30.298 C16.065,30.553,16.247,30.938,16.578,30.938z"/>
    </svg>
);

const PAYMENT_METHOD_ICONS: Record<string, IconType> = {
    'Cash': Icons.DOLLAR,
    'Check': Icons.CHECK,
    "Cashier's Check": Icons.CHECK,
    'E-Check': Icons.CHECK,
    'Money Order': Icons.PAYMENT,
    'Credit Card': Icons.CREDIT_CARD,
    'Debit Card': Icons.CREDIT_CARD,
    'ACH': Icons.BANK,
    'Wire Transfer': Icons.TRANSFER_FUNDS,
    'Apple Pay': Icons.APPLE_PAY,
    'Google Pay': Icons.GOOGLE_PAY,
    'PayPal': Icons.PAYPAL,
    'Venmo': Icons.VENMO,
    'CashApp': Icons.CASH_APP,
};

export function getPaymentMethodIconType(method: string): IconType | null {
    if (!method) return null;
    if (PAYMENT_METHOD_ICONS[method]) return PAYMENT_METHOD_ICONS[method];
    if (method.includes('heck')) return Icons.CHECK;
    return null;
}

type PaymentMethodIconProps = {
    method: string;
    label?: string;
    fallback?: IconType;
};

export function PaymentMethodIcon({method, label, fallback}: PaymentMethodIconProps): ReactElement {
    const displayLabel = label ?? method;

    if (method === 'Zelle') {
        return (
            <span className='payment-method-icon'>
                <ZelleSvg/>
                <span className='payment-method-icon__label'>{displayLabel}</span>
            </span>
        );
    }

    const iconType = getPaymentMethodIconType(method) ?? fallback;
    if (!iconType) return <span className='payment-method-icon'>{displayLabel}</span>;
    return (
        <span className='payment-method-icon'>
            <IconButton type={iconType} label={displayLabel}/>
        </span>
    );
}
